import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useSupplier, Supplier } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<Supplier>
      useData={useSupplier}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
